module.exports = __webpack_public_path__ + "img/2c.080c101c.svg";